import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

const requiredFirebaseEnvKeys = [
    "REACT_APP_FIREBASE_API_KEY",
    "REACT_APP_FIREBASE_AUTH_DOMAIN",
    "REACT_APP_FIREBASE_PROJECT_ID",
    "REACT_APP_FIREBASE_STORAGE_BUCKET",
    "REACT_APP_FIREBASE_MESSAGING_SENDER_ID",
    "REACT_APP_FIREBASE_APP_ID",
];

const missingFirebaseEnvKeys = requiredFirebaseEnvKeys.filter((key) => !process.env[key]);
if (missingFirebaseEnvKeys.length > 0) {
    throw new Error(`Missing Firebase env variables: ${missingFirebaseEnvKeys.join(", ")}`);
}

const firebaseConfig = {
    apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
    authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FIREBASE_APP_ID,
    measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || undefined,
};

const app = initializeApp(firebaseConfig);
export const analytics = typeof window !== "undefined" ? getAnalytics(app) : null;
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
const functionsRegion = process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || "us-central1";
export const functions = getFunctions(app, functionsRegion);

if (typeof window !== "undefined") {
    const host = window.location.hostname;
    const useEmulator = process.env.REACT_APP_USE_FUNCTIONS_EMULATOR === "true";
    if (useEmulator && (host === "localhost" || host === "127.0.0.1")) {
        connectFunctionsEmulator(functions, "127.0.0.1", 5001);
    }
}
